// superset fetches by `DocsAssistant_` prefixed event names
// see: [Docs Assistant Instrumentation](https://roblox.atlassian.net/wiki/spaces/CREATORSUCCESS/pages/2222982263/Docs+Assistant+Instrumentation)
const enum DocsAssistantEvent {
  // IMPRESSIONS:
  LoginRequiredDialog = 'DocsAssistant_LoginRequiredDialog',
  EntryPoint = 'DocsAssistant_EntryPoint',
  NullState = 'DocsAssistant_NullState',
  AccessDeniedErrorPage = 'DocsAssistant_AccessDeniedErrorPage',
  ConnectionStateChangeAlert = 'DocsAssistant_ConnectionStateChangeAlert',

  BotStartedStreamingResponse = 'DocsAssistant_BotStartedStreamingResponse',
  BotFinishedStreamingResponse = 'DocsAssistant_BotFinishedStreamingResponse',

  MessageByBot = 'DocAssistant_MessageByBot',
  MessageByUser = 'DocAssistant_MessageByUser',

  ConnectionReconnecting = 'DocsAssistant_ConnectionReconnecting',
  ConnectionReconnected = 'DocsAssistant_ConnectionReconnected',
  ConnectionClosed = 'DocsAssistant_ConnectionClosed',

  NullStateIntroGuideLink = 'DocsAssistant_NullStateIntroGuideLink',
  NullStateIntroStudioLink = 'DocsAssistant_NullStateIntroStudioLink',
  OptInMessage = 'DocAssistant_OptInMessage',

  // errors
  MessageError = 'DocsAssistant_MessageError',
  BotErroredStreamingResponse = 'DocsAssistant_BotErroredStreamingResponse',
  CreateConversationResponseError = 'DocsAssistant_CreateConversationResponseError',
  OptInGetAgreementInternalError = 'DocAssistant_OptInGetAgreementInternalError',
  OptInAcceptAgreementInternalError = 'DocAssistant_OptInAcceptAgreementInternalError',

  // CLICKS:
  UserClickedMessageRegenerateButton = 'DocsAssistant_UserClickedMessageRegenerateButton',
  UserRatedBotResponse = 'DocsAssistant_UserRatedBotResponse',
  UserStartedTypingTextInput = 'DocsAssistant_UserStartedTypingTextInput',
  UserClearedTextInput = 'DocsAssistant_UserClearedTextInput',
  UserSubmittedPrompt = 'DocsAssistant_UserSubmittedPrompt',
  UserClickedStopButton = 'DocsAssistant_UserClickedStopBotButton',

  UserClickedLoginRequiredDialogLoginButton = 'DocsAssistant_UserClickedLoginRequiredDialogLoginButton',

  UserClickedLinkInBotResponse = 'DocsAssistant_UserClickedLinkInBotResponse',

  UserClickedNullStateIntroStudioLink = 'DocsAssistant_UserClickedNullStateIntroStudioLink',
  UserClickedNullStateIntroGuideLink = 'DocsAssistant_UserClickedNullStateIntroGuideLink',
  UserClickedNullStateIntroStudioLinkDialogDownloadButton = 'DocsAssistant_UserClickedNullStateIntroStudioLinkDialogDownloadButton',
  OptInAccepted = 'DocsAssistant_OptInAccepted',
  OptInDeclined = 'DocsAssistant_OptInDeclined',
  OptInTermsOfService = 'DocsAssistant_OptInTermsOfService',
  OptInPrivacyPolicy = 'DocsAssistant_OptInPrivacyPolicy',
}

export default DocsAssistantEvent;
